/**
 * author:@varun
 */

// RECRUITER EXPERIENCE
angular.module('App.video.urls', ['jv.Common.Jobvite.Urls'])
.factory('videoServiceConstant', ['$jobviteUrls',
    function($jobviteUrls) {
        return {
            Urls: {
                'listApplication': $jobviteUrls.video + '/action/application/{0}/list', //GET, applicationEId
                'listContact': $jobviteUrls.video + '/action/contact/{0}/list', //GET, contactEId
                'questionnaire': $jobviteUrls.video + '/action/forms', //GET
                'videoInterviewMessageTemplate': $jobviteUrls.video + '/action/application/{0}/templates', // GET, id
                'videoInterviewMessageTemplateContact': $jobviteUrls.video + '/action/contact/{0}/templates', // GET, id
                'videoInterviewMessageTemplateNoApp': $jobviteUrls.video + '/action/video/interview/invitation/templates',
                'videoInterviewMessageTemplateMultiApp': $jobviteUrls.video + '/action/video/interview/invitation/templates?{0}',
                'previewQuestionnaireURL': $jobviteUrls.video + '/action/form/{0}/preview', //GET, id
                'sendVideoInterviewReminderTemplateURL': $jobviteUrls.video + '/action/video/interview/{0}/invitation/reminder/templates',
                'alreadyInvitedUsers': $jobviteUrls.video + '/action/video/interview/{0}/reviewers', //GET, formResponseId
                'inviteViewerTemplate': $jobviteUrls.video + '/action/video/interview/{0}/evaluation/request/templates', //formResponseId
                'evalReqMoreInformationTemplateURL': $jobviteUrls.video + '/action/video/interview/evaluation/{0}/more/detail/templates',
                'evalSendReminderTemplateURL': $jobviteUrls.video + '/action/video/interview/{0}/evaluation/reminder/templates', //formResponseID
                'appDetails': $jobviteUrls.jhire + '/action/application/{0}/applications',
                'sendVideoInterviewURL': $jobviteUrls.video + '/action/application/{0}/invite/{1}', //POST
                'interviewDetails': $jobviteUrls.video + '/action/{0}/form/response/{1}', // GET, id
                'sendVideoInterviewContactURL': $jobviteUrls.video + '/action/contact/{0}/invite/{1}', //POST
                'postEvaluations': $jobviteUrls.video + '/action/{0}/evaluation/{1}', //GET
                'sendVideoInterviewReminderURL': $jobviteUrls.video + '/action/{0}/video/interview/{1}/invitation/reminder', //GET, formResponseID
                'inviteReviewers': $jobviteUrls.video + '/action/{0}/video/interview/{1}/evaluation/request', //POST formResponseId
                'evaluations': $jobviteUrls.video + '/action/{0}/form/response/{1}/evaluations', //GET
                'allEvaluations': $jobviteUrls.video + '/action/application/{0}/evaluations', //GET
                'evalSendReminderURL': $jobviteUrls.video + '/action/{0}/video/interview/{1}/evaluation/reminder', //GET, formResponseID
                'evalReqMoreInformationURL': $jobviteUrls.video + '/action/{0}/video/interview/evaluation/{1}/more/detail', //GET, formResponseID
                'reinviteCandidate': $jobviteUrls.video + '/action/form/response/{0}/reinvite', //GET, formResponseID
                'inviteAdHocInterview': $jobviteUrls.video + '/action/video/interview/adhoc/invitation/{0}', //{formId}
                'inviteWorkflowInterview': $jobviteUrls.video + '/action/video/interview/workflow/invitation',
                'validateSendVideoForApplications': $jobviteUrls.video + '/action/video/interview/application/info',
                'videoPermissions': $jobviteUrls.video + '/action/application/{0}/views',
                //TODO: fill this value with the backend value.
                'videoInterviewCount': $jobviteUrls.video + '/action/application/{0}/video/count',
                'grantExtension': $jobviteUrls.video + '/action/application/{0}/extendInvite/{1}',
                'isVonageEnabled': $jobviteUrls.video + '/action/user/video/getVonageStatus'
            }
        };
    }
]);

angular.module('App.video.service', ['App.video.urls', 'App.ajax.service'])
    /**
        Set all the page specific properties here so that they can be read here.
    */
    .service('videoPageService',[function(){
        var videoPageService = {};
        var _pageTypes = ['CANDIDATE_DETAIL','CONTACT_DETAIL'];
        var pageType = 'CANDIDATE_DETAIL';
        
        // setter for the page type.
        videoPageService.setPageType = function( type ){
            var index = _pageTypes.indexOf(type);
            if(index<0){
                //error: Can not set invalid type for the page.
                return;
            }
            pageType = type;
        };

        //getter for the page type.
        videoPageService.getPageType = function(){
            return pageType;
        };

        //Convenience methods
        videoPageService.isContact = function(){
            return pageType === 'CONTACT_DETAIL';
        };
        videoPageService.isCandidate  = function(){
            return pageType === 'CANDIDATE_DETAIL';
        };

        return videoPageService;

    }])
    .service('appDetailsService', [function() {
        var appDetailsService = {};
        var applicantName = '';

        appDetailsService.setApplicantName = function(name){
            applicantName = name;
        };

        appDetailsService.getApplicantName = function(){
            return applicantName;
        };

        return appDetailsService;

    }])
    .service('videoService', ['videoPageService', 'videoServiceConstant', 'makeAjaxCall', '$window', '$timeout', '$rootScope', '$location',
        function(videoPageService, videoServiceConstant, makeAjaxCall, $window, $timeout, $rootScope, $location) {

            var videoService = {};

            //FIXIT: We have do too much dependance on routeParams. For Video we should pass everything as object
            //for the service.
            var applicationId = $location.path().split('/')[3] || $location.search().applicationId;
            /**
             *  Utility for calling the ajax functions.
             */
            function createRequestObject(args, callback, options) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = options.ajaxtype;
                requestObj.url = options.url;
                requestObj.requestType = options.requestType; //default is GET
                requestObj.cache = options.cache; //default is false
                //All the video calls for recruiter use case need traditional way of serializing. 
                requestObj.traditional = true;
                var requestPromise = makeAjaxCall(requestObj);
                requestPromise.then(function(results) {
                    callback(results.data, results.status);
                });
            }


            /*****************************************************
            *   Get the list of Applications for Contacts or Candidates.
            *****************************************************/
            videoService.getApplicationList = function(args, callback) {
                if (!args.eID) {
                    return;
                }
                // Redirect to the proper API call.
                (videoPageService.isContact()? videoService.getContactsApplicationList:videoService.getCandidatesApplicationList)(args,callback);
            };
            videoService.getContactsApplicationList = function(args, callback){
                var options = {
                    'ajaxtype': 'getContactVideoListForRecruiter',
                    'url': videoServiceConstant.Urls.listContact.format(args.eID),
                    'cache': true
                };
                delete args.eID;
                createRequestObject(args, callback, options);
            };
            videoService.getCandidatesApplicationList = function(args, callback){
                var options = {
                    'ajaxtype': 'getApplicationVideoListForRecruiter',
                    'url': videoServiceConstant.Urls.listApplication.format(args.eID),
                    'cache': true
                };
                delete args.eID;
                createRequestObject(args, callback, options);
            };
            /*****************************************************/
            /*****************************************************/

            // Get the details of the interview.
            videoService.getInterviewDetails = function(args, callback) {
                if (!args.id) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'getVideoInterviewDetailsForRecruiter',
                    'url': videoServiceConstant.Urls.interviewDetails.format(args.appId, args.id)
                };
                delete args.id;
                createRequestObject(args, callback, options);
            };

            //Ajax call to check Vonage or flash
            videoService.isVonageEnabled = function(args, callback) {
                var expectedJson = {'isVonage':true};
                callback(expectedJson);
            };

            // Get the List of Video Questionnaires
            videoService.getQuestionnaires = function(args, callback) {
                var options = {
                    'ajaxtype': 'getQuestionnairesForRecruiter',
                    'url': videoServiceConstant.Urls.questionnaire
                };

                if (args.jobEId === null) {
                    delete args.jobEId;
                }

                if (args.workflowStateKind === null) {
                    delete args.workflowStateKind;
                }
                createRequestObject(args, callback, options);
            };

            //Get the list of Message Tempalates for Video Interviewing.
            videoService.getMessageTemplates = function(isContact, args, callback) {
                var ajaxUrl;
                if ((typeof args.applications === 'string') || args.applications.length === 1) {
                    if (isContact) {
                        ajaxUrl = videoServiceConstant.Urls.videoInterviewMessageTemplateContact.format(args.applications[0]);
                    } else {
                        ajaxUrl = videoServiceConstant.Urls.videoInterviewMessageTemplate.format(args.applications[0]);
                    }
                } else {
                    if(angular.isArray(args.applications) && args.applications.length> 1){
                        ajaxUrl = videoServiceConstant.Urls.videoInterviewMessageTemplateMultiApp.format($.param({
                            applicationEIds: args.applications
                        }));
                    }else{
                         ajaxUrl = videoServiceConstant.Urls.videoInterviewMessageTemplateNoApp;
                    }
                }

                var options = {
                    'ajaxtype': 'getMessageTemplates',
                    'url': ajaxUrl
                };
                delete args.applications;
                createRequestObject(args, callback, options);
            };

            //Call the Send Video Interview Endpoint.
            videoService.sendVideoInterview = function(isContact, args, callback) {
                var ajaxUrl;
                if (!args.questionID) {
                    //Missing Question ID
                    return;
                }

                if (isContact) {
                    ajaxUrl = videoServiceConstant.Urls.sendVideoInterviewContactURL.format(args.applicationEIds, args.questionID);
                } else {
                    ajaxUrl = videoServiceConstant.Urls.sendVideoInterviewURL.format(args.applicationEIds, args.questionID);
                }

                var options = {
                    'ajaxtype': 'sendVideoInterviewForRecruiter',
                    'url': ajaxUrl,
                    'requestType': 'POST'
                };
                delete args.questionID;
                createRequestObject(args, callback, options);
            };

            videoService.sendVideoInterviewReminder = function(args, callback) {
                if (!args.formID) {
                    return;
                }
             applicationId = applicationId ?  applicationId : args.applicationEIds;
                var options = {
                    'ajaxtype': 'sendVideoInterviewReminderForRecruiter',
                    'url': videoServiceConstant.Urls.sendVideoInterviewReminderURL.format(applicationId, args.formID),
                    'requestType': 'POST'
                };
                delete args.formID;

                createRequestObject(args, callback, options);
            };

            videoService.sendVideoInterviewReminderTemplate = function(args, callback) {
                if (!args.formID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'sendVideoInterviewReminderTemplateForRecruiter',
                    'url': videoServiceConstant.Urls.sendVideoInterviewReminderTemplateURL.format(args.formID)
                };
                delete args.formID;
                createRequestObject(args, callback, options);
            };

            videoService.evalRequestMoreInformation = function(args, callback) {
                if (!args.evalID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'evalRequestMoreInformation',
                    'url': videoServiceConstant.Urls.evalReqMoreInformationURL.format(applicationId, args.evalID),
                    'requestType': 'POST'
                };
                delete args.evalID;

                createRequestObject(args, callback, options);
            };

            videoService.evalRequestMoreInformationTemplates = function(args, callback) {
                if (!args.formID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'evalRequestMoreInformationTemplates',
                    'url': videoServiceConstant.Urls.evalReqMoreInformationTemplateURL.format(args.formID)
                };
                delete args.formID;

                createRequestObject(args, callback, options);
            };

            videoService.evalSendReminder = function(args, callback) {
                if (!args.formID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'evalSendReminder',
                    'url': videoServiceConstant.Urls.evalSendReminderURL.format(applicationId, args.formID),
                    'requestType': 'POST'
                };

                createRequestObject(args, callback, options);
            };


            //Get the list of Message Tempalates for Video Interviewing.
            videoService.evalSendReminderTemplates = function(args, callback) {
                if (!args.formID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'getEvalSendReminderTemplates',
                    'url': videoServiceConstant.Urls.evalSendReminderTemplateURL.format(args.formID)
                };
                delete args.formID;
                createRequestObject(args, callback, options);
            };

            //Get the list of Message Templates for Send Video Interview Reminder
            videoService.sendVideoInterviewReminderTemplates = function(args, callback) {
                if (!args.formID) {
                    return;
                }

                var options = {
                    'ajaxtype': 'sendVideoInterviewReminderTemplates',
                    'url': videoServiceConstant.Urls.sendVideoInterviewReminderTemplateURL.format(args, formID)
                };

                delete args.formID;
                createRequestObject(args, callback, options);
            };

            videoService.previewQuestionnaire = function(args, callback) {
                if (!args.questionID) {
                    //Missing Question ID
                    return;
                }
                // $rootScope.$evalAsync(function(){
                //  var result = {'time':600,'bean':{'questions':[{'sequence':1,'timeToAnswer':60,'title':'What is your name?'},{'sequence':2,'timeToAnswer':120,'title':'How old are you?'},{'sequence':3,'timeToAnswer':180,'title':'What is 1 + 2?'},{'sequence':4,'timeToAnswer':240,'title':'Is the sky blue?'}],'title':'Interview for Software Engineer'}};
                //  callback(result, 200);
                // });
                // return;

                var options = {
                    'ajaxtype': 'previewQuestionnaireForSendVideoInterviewwModal',
                    'url': videoServiceConstant.Urls.previewQuestionnaireURL.format(args.questionID)
                };
                delete args.questionID;
                createRequestObject(args, callback, options);
            };

            videoService.getEvaluations = function(args, callback) {
                //interviewId
                if (!args.id) {
                    //missing applicationEId
                    return;
                }
                if(angular.isDefined(args.appId)){
                    applicationId = args.appId;
                }
                var options = {
                    'ajaxtype': 'getEvaluationForVideo',
                    'url': videoServiceConstant.Urls.evaluations.format(applicationId, args.id)
                };
                delete args.id;
                createRequestObject(args, callback, options);
            };



            //$routeParam might not have the application Id.
            videoService.getAllEvaluations = function(args, callback) {
                if (!args.applicationEId) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'getAllEvaluationForVideo',
                    'url': videoServiceConstant.Urls.allEvaluations.format(args.applicationEId)
                };
                delete args.id;
                createRequestObject(args, callback, options);
            };



            videoService.submitEvaluations = function(args, callback) {

                //comment=&rating=&overallComment=&overallRating=&submit=[true|false]

                //videoId
                if (!args.vid) {
                    //missing applicationEId
                    return;
                }
                if(angular.isDefined(args.appId)){
                    applicationId = args.appId;
                }
                var options = {
                    'ajaxtype': 'submitEvaluationForVideo',
                    'url': videoServiceConstant.Urls.postEvaluations.format(applicationId, args.vid),
                    'requestType': 'POST'
                };
                delete args.vid;
                createRequestObject(args, callback, options);
            };
            
            videoService.invitedUsers = function(args, callback) {
                if (!args.id) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'getListOfAlreadyInvitedUsers',
                    'url': videoServiceConstant.Urls.alreadyInvitedUsers.format(args.id),
                };
                delete args.id;
                createRequestObject(args, callback, options);

                //TODO: remove the below after testing. just for testing.
                // $rootScope.$evalAsync(function(){
                //  var resultList = ['532','5139','511','5138','5152'];
                //  callback(resultList);
                // });
            };

            videoService.inviteMessageTemplate = function(args, callback) {
                if (!args.formResponseId) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'getInviteViewerTemplate',
                    'url': videoServiceConstant.Urls.inviteViewerTemplate.format(args.formResponseId),
                };
                delete args.formResponseId;
                createRequestObject(args, callback, options);

                //TODO: remove the below after testing. just for testing.
                // $rootScope.$evalAsync(function(){
                //  var result = {'resultList":[{"EId":"joV9Vfw7","body":"Dear ,\n\nPlease review and complete an evaluation of the video interview submitted for","isDefault":true,"subject":"Please review video interview","title":"Message Template - Video invite"}]};
                //  callback(result);
                // });

            };

            videoService.inviteReviewers = function(args, callback) {
                if (!args.formObj.id) {
                    //missing applicationEId
                    return;
                }
                if(angular.isDefined(args.appId)){
                    applicationId = args.appId;
                }
                var options = {
                    'ajaxtype': 'getListOfAlreadyInvitedUsers',
                    'url': videoServiceConstant.Urls.inviteReviewers.format(applicationId, args.formObj.id),
                    'requestType': 'POST'
                };
                delete args.formObj.id;
                createRequestObject(args.formObj, callback, options);
            };

            videoService.getAppDetails = function(args, callback) {
                if (!args.id) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'getAppDetailsForPrintedEvaluations',
                    'url': videoServiceConstant.Urls.appDetails.format(args.id)
                };
                delete args.id;
                createRequestObject(args, callback, options);
            };

            // Reinvite the candidate
            videoService.reinviteCandidate = function(args, callback) {
                if (!args.formResponseId) {
                    //missing applicationEId
                    return;
                }
                var options = {
                    'ajaxtype': 'reinviteCandidateModal',
                    'url': videoServiceConstant.Urls.reinviteCandidate.format(args.formResponseId),
                    'requestType': 'POST'
                };
                delete args.formResponseId;
                createRequestObject(args, callback, options);
            };
            
         // Extend Interview Invite
            videoService.extendInterviewInvite = function(args, callback) {
               // alert('extendInterviewInvite from video svc');
            };

            videoService.validateApplications = function(args, callback) {
                if (!args.applicationEIds) {
                    return;
                }
                var options = {
                    'ajaxtype': 'validateApplicationsToSendVideoInvite',
                    'url': videoServiceConstant.Urls.validateSendVideoForApplications,
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            videoService.inviteWorkflowInterview = function(args, callback) {
                if (!args.applicationEIds) {
                    return;
                }
                var options = {
                    'ajaxtype': 'getinviteWorkflowInterview',
                    'url': videoServiceConstant.Urls.inviteWorkflowInterview,
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            videoService.inviteAdHocInterview = function(args, callback) {
                if (!args.applicationEIds || !args.questionID) {
                    return;
                }
                var options = {
                    'ajaxtype': 'getinviteAdHocInterview',
                    'url': videoServiceConstant.Urls.inviteAdHocInterview.format(args.questionID),
                    'requestType': 'POST'
                };

                delete args.questionID;
                createRequestObject(args, callback, options);
            };

            // Get Video permissions.
            videoService.getVideoPermissions = function(applicationId,callback){
                if (angular.isUndefined(applicationId)){
                    return;
                }
                var options = {
                    'ajaxtype': 'getVideoPermissions',
                    'url': videoServiceConstant.Urls.videoPermissions.format(applicationId),
                    'requestType': 'GET'
                };
                createRequestObject({}, callback, options);
            };

            // Get the count for the completed video interviews for this application.
            videoService.getCompleteVideoInterviewCount = function(applicationId,callback){
                if (angular.isUndefined(applicationId)){
                    return;
                }
                var options = {
                    'ajaxtype': 'getVideoInterviewCount',
                    'url': videoServiceConstant.Urls.videoInterviewCount.format(applicationId),
                    'requestType': 'GET'
                };
                createRequestObject({}, callback, options);
            };


            videoService.grantExtension = function(args, callback){
                if (angular.isUndefined(args.applicationEIds) && angular.isUndefined(args.vfrId) ){
                    return;
                }
                var options = {
                    'ajaxtype': 'grantExtension',
                    'url': videoServiceConstant.Urls.grantExtension.format(args.applicationEIds, args.vfrId),
                    'requestType': 'POST'
                };
                delete args.applicationId;
                delete args.vfrId;
                createRequestObject(args, callback, options);
            };

            return videoService;
        }
    ]);
